// Normal debounce (lodash debounce) only executes function but does not return promise.
// For formik validation we need promise to be returned.
// Otherwise validation result applies only on blur and not on change. which is bad ux
// This implementation solves that problem.
// Used for neverbounce email validation.
// Formik specific debounced validations works only on Form level. While our approach requires field level validation
// https://stackoverflow.com/a/54265129
/**
 *
 * @param fn callback
 * @param wait milliseconds
 * @param abortValue if has abortValue, promise will reject it if
 * @returns Promise
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debouncePromise<T extends (...args: any[]) => any>(
  fn: T,
  wait: number,
  abortValue: unknown = undefined,
) {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  let cancel = () => {}
  // type Awaited<T> = T extends PromiseLike<infer U> ? U : T
  type ReturnT = Awaited<ReturnType<T>>
  const wrapFunc = (...args: Parameters<T>): Promise<ReturnT> => {
    cancel()
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => resolve(fn(...args)), wait)
      cancel = () => {
        clearTimeout(timer)
        if (abortValue !== undefined) {
          reject(abortValue)
        }
      }
    })
  }
  return wrapFunc
}
